export default __webpack_public_path__ + "static/media/acceptedInvoice.4839ad06.svg";